<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="error headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>
    <br />
    Key code : {{plsc.plsc_code}} <br/>
    <br/>
    Start date: {{plsc.plsc_datum}} <br />
    <br />
    Are you sure you want to remove ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="error mx-2" small @click="rmPlsc">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      plsc_encrid: null,
      plsc: {}
    }
  },
  methods: {
    open(plsc_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hspl/plsc/getPlsc.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getPlsc"
          },
          getPlsc: {
            plsc_encrid: plsc_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.plsc = res.data.getPlsc;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmPlsc() { 
      this.$axios
        .post("ares/json/ares/huis/hspl/plsc/rmPlsc.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmPlsc"
          },
          rmPlsc: {
            plsc_encrid: this.plsc.plsc_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmPlsc.text,
              color: res.data.rmPlsc.color
            });
            this.dialog = false;
          }
        })
    },
  }
}
</script>

